import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../../shared/services/base.service';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { Utility } from '../../../common/utility';
import { ValidationService } from '../../../shared/services/validation.service';
import { MatTabsModule, MatTabChangeEvent } from '@angular/material';

@Component({
  selector: 'list-member',
  templateUrl: 'list-member.component.html'
})
export class ListMemberComponent implements OnInit {
  @ViewChild('smallgroup') smallGroup;
  @ViewChild('largegroup') largeGroup;
  constructor(
    public utility: Utility,
    private formBuilder: FormBuilder,
    private router: Router) {}

  ngOnInit() {
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent) {
    if (tabChangeEvent.index === 1) {
      this.largeGroup.rerender();
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/list-member/list-member.component.ts